import { expValEqualsNoExposure } from '@atlaskit/tmp-editor-statsig/exp-val-equals-no-exposure';

const KEYCAP_COMBINING = 0x20e3;
const VARIATION_SELECTOR_16 = 0xfe0f;
const VARIATION_SELECTOR_15 = 0xfe0e;
const EMOJI_MODIFIER_START = 0x1f3fb;
const EMOJI_MODIFIER_END = 0x1f3ff;
const REGIONAL_INDICATOR_START = 0x1f1e6;
const REGIONAL_INDICATOR_END = 0x1f1ff;
const FLAG_BASES = new Set<number>([0x1f38c, 0x1f3c1, 0x1f3f3, 0x1f3f4, 0x1f6a9]);

// Emoji variation bases from Unicode 14.0 emoji-variation-sequences.txt.
// These are the code points with a defined U+FE0F emoji-style variant.
const EMOJI_VARIATION_BASES = new Set<number>([
	0x0023, 0x002a, 0x0030, 0x0031, 0x0032, 0x0033, 0x0034, 0x0035, 0x0036, 0x0037, 0x0038, 0x0039,
	0x00a9, 0x00ae, 0x203c, 0x2049, 0x2122, 0x2139, 0x2194, 0x2195, 0x2196, 0x2197, 0x2198, 0x2199,
	0x21a9, 0x21aa, 0x2328, 0x23cf, 0x23ed, 0x23ee, 0x23ef, 0x23f1, 0x23f2, 0x23f8, 0x23f9, 0x23fa,
	0x24c2, 0x25aa, 0x25ab, 0x25b6, 0x25c0, 0x25fb, 0x25fc, 0x2600, 0x2601, 0x2602, 0x2603, 0x2604,
	0x260e, 0x2611, 0x2618, 0x261d, 0x2620, 0x2622, 0x2623, 0x2626, 0x262a, 0x262e, 0x262f, 0x2638,
	0x2639, 0x263a, 0x2640, 0x2642, 0x265f, 0x2660, 0x2663, 0x2665, 0x2666, 0x2668, 0x267b, 0x267e,
	0x2692, 0x2694, 0x2695, 0x2696, 0x2697, 0x2699, 0x269b, 0x269c, 0x26a0, 0x26a7, 0x26b0, 0x26b1,
	0x26c8, 0x26cf, 0x26d1, 0x26d3, 0x26e9, 0x26f0, 0x26f1, 0x26f4, 0x26f7, 0x26f8, 0x26f9, 0x2702,
	0x2708, 0x2709, 0x270c, 0x270d, 0x270f, 0x2712, 0x2714, 0x2716, 0x271d, 0x2721, 0x2733, 0x2734,
	0x2744, 0x2747, 0x2763, 0x2764, 0x27a1, 0x2934, 0x2935, 0x2b05, 0x2b06, 0x2b07, 0x3030, 0x303d,
	0x3297, 0x3299, 0x1f170, 0x1f171, 0x1f17e, 0x1f17f, 0x1f202, 0x1f237, 0x1f321, 0x1f324, 0x1f325,
	0x1f326, 0x1f327, 0x1f328, 0x1f329, 0x1f32a, 0x1f32b, 0x1f32c, 0x1f336, 0x1f37d, 0x1f396, 0x1f397,
	0x1f399, 0x1f39a, 0x1f39b, 0x1f39e, 0x1f39f, 0x1f3cb, 0x1f3cc, 0x1f3cd, 0x1f3ce, 0x1f3d4, 0x1f3d5,
	0x1f3d6, 0x1f3d7, 0x1f3d8, 0x1f3d9, 0x1f3da, 0x1f3db, 0x1f3dc, 0x1f3dd, 0x1f3de, 0x1f3df, 0x1f3f3,
	0x1f3f5, 0x1f3f7, 0x1f43f, 0x1f441, 0x1f4fd, 0x1f549, 0x1f54a, 0x1f56f, 0x1f570, 0x1f573, 0x1f574,
	0x1f575, 0x1f576, 0x1f577, 0x1f578, 0x1f579, 0x1f587, 0x1f58a, 0x1f58b, 0x1f58c, 0x1f58d, 0x1f590,
	0x1f5a5, 0x1f5a8, 0x1f5b1, 0x1f5b2, 0x1f5bc, 0x1f5c2, 0x1f5c3, 0x1f5c4, 0x1f5d1, 0x1f5d2, 0x1f5d3,
	0x1f5dc, 0x1f5dd, 0x1f5de, 0x1f5e1, 0x1f5e3, 0x1f5e8, 0x1f5ef, 0x1f5f3, 0x1f5fa, 0x1f6cb, 0x1f6cd,
	0x1f6ce, 0x1f6cf, 0x1f6e0, 0x1f6e1, 0x1f6e2, 0x1f6e3, 0x1f6e4, 0x1f6e5, 0x1f6e9, 0x1f6f0, 0x1f6f3,
	0x231a, 0x231b, 0x23e9, 0x23ea, 0x23f3, 0x25fd, 0x25fe, 0x2614, 0x2615, 0x2648, 0x2649, 0x264a,
	0x264b, 0x264c, 0x264d, 0x264e, 0x264f, 0x2650, 0x2651, 0x2652, 0x2653, 0x267f, 0x2693, 0x26a1,
	0x26aa, 0x26ab, 0x26bd, 0x26be, 0x26c4, 0x26c5, 0x26d4, 0x26ea, 0x26f2, 0x26f3, 0x26f5, 0x26fa,
	0x26fd, 0x2753, 0x2757, 0x2b1b, 0x2b1c, 0x2b50, 0x2b55, 0x1f004, 0x1f21a, 0x1f22f, 0x1f30d,
	0x1f30e, 0x1f30f, 0x1f315, 0x1f31c, 0x1f378, 0x1f393, 0x1f3a7, 0x1f3ac, 0x1f3ad, 0x1f3ae, 0x1f3c2,
	0x1f3c4, 0x1f3c6, 0x1f3ca, 0x1f3e0, 0x1f3ed, 0x1f408, 0x1f415, 0x1f41f, 0x1f426, 0x1f442, 0x1f446,
	0x1f447, 0x1f448, 0x1f449, 0x1f44d, 0x1f44e, 0x1f453, 0x1f46a, 0x1f47d, 0x1f4a3, 0x1f4b0, 0x1f4b3,
	0x1f4bb, 0x1f4bf, 0x1f4cb, 0x1f4da, 0x1f4df, 0x1f4e4, 0x1f4e5, 0x1f4e6, 0x1f4ea, 0x1f4eb, 0x1f4ec,
	0x1f4ed, 0x1f4f7, 0x1f4f9, 0x1f4fa, 0x1f4fb, 0x1f508, 0x1f50d, 0x1f512, 0x1f513, 0x1f550, 0x1f551,
	0x1f552, 0x1f553, 0x1f554, 0x1f555, 0x1f556, 0x1f557, 0x1f558, 0x1f559, 0x1f55a, 0x1f55b, 0x1f55c,
	0x1f55d, 0x1f55e, 0x1f55f, 0x1f560, 0x1f561, 0x1f562, 0x1f563, 0x1f564, 0x1f565, 0x1f566, 0x1f567,
	0x1f610, 0x1f687, 0x1f68d, 0x1f691, 0x1f694, 0x1f698, 0x1f6ad, 0x1f6b2, 0x1f6b9, 0x1f6ba, 0x1f6bc,
]);

const isEmojiModifier = (codePoint: number | undefined): boolean =>
	typeof codePoint === 'number' &&
	codePoint >= EMOJI_MODIFIER_START &&
	codePoint <= EMOJI_MODIFIER_END;

const shouldAddEmojiPresentationSelector = (codePoint: number, nextCodePoint: number | undefined) =>
	EMOJI_VARIATION_BASES.has(codePoint) &&
	nextCodePoint !== VARIATION_SELECTOR_16 &&
	nextCodePoint !== VARIATION_SELECTOR_15 &&
	nextCodePoint !== KEYCAP_COMBINING &&
	!isEmojiModifier(nextCodePoint);

const isRegionalIndicator = (codePoint: number): boolean =>
	codePoint >= REGIONAL_INDICATOR_START && codePoint <= REGIONAL_INDICATOR_END;

const parseEmojiIdCodePoints = (id: string): number[] | undefined => {
	const segments = id.split('-');
	const codePoints: number[] = [];

	for (const segment of segments) {
		if (!/^[0-9a-fA-F]+$/.test(segment)) {
			return undefined;
		}
		const cp = parseInt(segment, 16);
		// Valid Unicode scalar values: U+0000–U+10FFFF, excluding surrogates.
		if (isNaN(cp) || cp < 0 || cp > 0x10ffff || (cp >= 0xd800 && cp <= 0xdfff)) {
			return undefined;
		}
		codePoints.push(cp);
	}

	return codePoints.length ? codePoints : undefined;
};

const isFlagEmoji = (codePoints: number[]): boolean => {
	if (codePoints.length === 2 && codePoints.every(isRegionalIndicator)) {
		return true;
	}

	return FLAG_BASES.has(codePoints[0]);
};

/**
 * Converts an emoji ID (a hyphen-separated string of hex Unicode code points,
 * e.g. `"1f44d"`, `"1f44d-1f3fb"`, `"1f468-200d-1f469-200d-1f467"`) into its
 * corresponding Unicode string.
 *
 * Special handling:
 * - Keycap sequences: U+20E3 (COMBINING ENCLOSING KEYCAP) must be preceded by
 *   U+FE0F (VARIATION SELECTOR-16) to form a well-defined keycap emoji.
 * - Emoji variation bases are followed by U+FE0F to force emoji presentation.
 * - Flags return `undefined` so callers use Twemoji instead of native emoji.
 *
 * @returns The Unicode string for the emoji, or `undefined` if the input is
 *   invalid (empty string, non-hex segments, or out-of-range code points).
 */
export function emojiIdToEmoji(id: string): string | undefined {
	if (!expValEqualsNoExposure('platform_use_unicode_emojis', 'isEnabled', true)) {
		return undefined;
	}

	if (!id) {
		return undefined;
	}

	const codePoints = parseEmojiIdCodePoints(id);
	if (!codePoints) {
		return undefined;
	}

	if (isFlagEmoji(codePoints)) {
		return undefined;
	}

	const processedCodePoints: number[] = [];
	for (let i = 0; i < codePoints.length; i++) {
		const cp = codePoints[i];
		const next = codePoints[i + 1];

		processedCodePoints.push(cp);

		// Insert U+FE0F before U+20E3 if not already present.
		// Keycap sequences: digit/# /* followed by U+20E3 need U+FE0F between them.
		if (next === KEYCAP_COMBINING && cp !== VARIATION_SELECTOR_16) {
			processedCodePoints.push(VARIATION_SELECTOR_16);
		}

		// Emoji variation bases need U+FE0F immediately after the base code point,
		// including when the base appears inside a ZWJ sequence.
		if (shouldAddEmojiPresentationSelector(cp, next)) {
			processedCodePoints.push(VARIATION_SELECTOR_16);
		}
	}

	try {
		return String.fromCodePoint(...processedCodePoints);
	} catch {
		return undefined;
	}
}
